import React, { useRef } from 'react';
import styles from './O_FileUploads.module.css';
import M_File, { M_FileProps } from '@/components/M_Molecules/M_File/M_File';
import Q_ScrollBar from '@/components/Q_Quarks/Q_ScrollBar/Q_ScrollBar';

interface O_FileUploadsProps {
  files: M_FileProps[];
  onDeleteFile: (index: number) => void;
  onOpenFile: (index: number) => void;
}

export default function O_FileUploads({
  files,
  onDeleteFile,
  onOpenFile,
}: O_FileUploadsProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  if (files.length === 0) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div ref={containerRef} className={styles.files_wrapper}>
        {files.map((file, index) => (
          <M_File
            key={index}
            image={file.image}
            format={file.format}
            size={file.size}
            mediaType={file.mediaType}
            hasDescription={file.hasDescription}
            onOpen={() => onOpenFile(index)}
            onDelete={() => onDeleteFile(index)}
          />
        ))}
      </div>
      <Q_ScrollBar containerRef={containerRef} className={styles.scroll_bar} />
    </div>
  );
}
